import styled from 'styled-components';

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

export const UploadSectionStyle = styled.div`
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
`;

export const FileUploadForm = styled.form`
  width: 100%;
`;

export const FileInput = styled.input`
  display: block;
  width: 100%;
  padding: 0.5rem;
  margin: 0.5rem 0 1rem 0;
  border: 1px solid #d1d5db;
  border-radius: 4px;
`;

export const CheckboxContainer = styled.div`
  margin: 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ToggleContainer = styled.div`
  margin-bottom: 2rem;
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ToggleButtons = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const ToggleButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.active ? `
    background-color: #3b82f6;
    color: white;
  ` : `
    background-color: #f3f4f6;
    color: #4b5563;
    
    &:hover {
      background-color: #e5e7eb;
    }
  `}
`;

export const TableContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 2rem;
`;

export const ResultsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
`;

export const Th = styled.th`
  text-align: left;
  padding: 1rem;
  border-bottom: 2px solid #e5e7eb;
`;

export const Td = styled.td`
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
`;

export const IconCell = styled(Td)`
  width: 60px;
`;

export const HashLink = styled.a`
  color: #2563eb;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const UploadStatus = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 4px;
  ${props => props.success && `
    background-color: #d1fae5;
    color: #065f46;
  `}
  ${props => props.warning && `
    background-color: #fef3c7;
    color: #92400e;
  `}
`;

export const MalwareFamilyBadge = styled.span`
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  
  ${props => props.type === 'unknown' ? `
    background-color: #f3f4f6;
    color: #4b5563;
  ` : `
    background-color: #fee2e2;
    color: #991b1b;
  `}
`;

export const StatusBadge = styled.span`
  position: relative;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  
  ${props => {
    switch (props.status) {
      case 'completed':
        return `
          background-color: #dcfce7;
          color: #166534;
        `;
      case 'analyzing':
        return `
          background-color: #dbeafe;
          color: #1e40af;
        `;
      case 'failed':
        return `
          background-color: #fee2e2;
          color: #991b1b;
        `;
      default:
        return `
          background-color: #f3f4f6;
          color: #4b5563;
        `;
    }
  }}
`;

export const AppIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 8px;
`;

export const ButtonContainer = styled.div`
  display: inline-block;
  
  & > button:first-child {
    margin-right: 0.75rem;
  }
`;

export const IntelButton = styled.button`
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 32px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  ${props => props.type === 'playstore' && `
    background-color: #34d399;
    color: white;
    border: none;
    
    &:hover {
      background-color: #059669;
    }

    &:disabled {
      background-color: #d1d5db;
      cursor: not-allowed;
    }
  `}
  
  ${props => props.type === 'virustotal' && `
    background-color: #60a5fa;
    color: white;
    border: none;
    
    &:hover {
      background-color: #2563eb;
    }

    &:disabled {
      background-color: #d1d5db;
      cursor: not-allowed;
    }
  `}
`;

export const LoadingSpinner = styled.div`
  text-align: center;
  padding: 2rem;
  color: #4b5563;
`;

export const ErrorMessage = styled.div`
  color: #dc2626;
  background-color: #fee2e2;
  border: 1px solid #fecaca;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
`;

// Shared styles from old implementation
export const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  
  ${props => props.primary ? `
    background-color: #3b82f6;
    color: white;
    border: none;
    
    &:hover {
      background-color: #2563eb;
    }
  ` : `
    background-color: #f3f4f6;
    color: #4b5563;
    border: 1px solid #d1d5db;
    
    &:hover {
      background-color: #e5e7eb;
    }
  `}
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
`;

export const PageTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #111827;
`;

export const StatusWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
`;

export const ErrorTooltip = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 0.3rem;
  cursor: default;
  color: inherit;
  font-size: 0.8rem;

  &:hover > span {
    display: block;
  }

  > span {
    display: none;
    position: absolute;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    background: #1f2937;
    color: #f9fafb;
    font-size: 0.85rem;
    line-height: 1.5;
    padding: 0.6rem 0.8rem;
    border-radius: 6px;
    white-space: normal;
    width: max-content;
    max-width: 500px;
    z-index: 10;
    font-weight: 400;
  }
`;

